/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const VariableIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="VariableIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              opacity="0.4"
              d="M3.75736 8H3C2.44772 8 2 8.44772 2 9V13C2 13.5523 2.44772 14 3 14L11 14C10.2317 14 9.53084 13.7112 9.00009 13.2362V13.2427L8.75736 13L3 13L3 9L4.75736 9L3.75736 8Z"
              fill="currentColor"
            />
            <g>
              <path
                d="M10.9999 10C11.5522 10 11.9999 10.4477 11.9999 11C11.9999 11.5523 11.5522 12 10.9999 12C10.4476 12 9.99992 11.5523 9.99992 11C9.99992 10.4477 10.4476 10 10.9999 10Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9999 2C13.5522 2 13.9999 2.44772 13.9999 3V11C13.9999 12.6569 12.6568 14 10.9999 14C10.2305 14 9.53096 13.7077 8.99992 13.2314V13.2432L3.2216 7.46484C2.83108 7.07432 2.83108 6.44033 3.2216 6.0498L6.04973 3.22168C6.44016 2.83125 7.07325 2.83143 7.46379 3.22168L7.99992 3.75781V3C7.99992 2.44772 8.44764 2 8.99992 2H12.9999ZM8.99992 11C8.99992 12.1046 9.89536 13 10.9999 13C12.1045 13 12.9999 12.1046 12.9999 11V3H8.99992V11ZM3.92864 6.75781L7.99992 10.8281V5.17188L6.75676 3.92871L3.92864 6.75781Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

VariableIcon.tags = ['statistics', 'graph', 'chart', 'data', 'analysis'];

VariableIcon.category = 'General Icons';

VariableIcon.iconSize = 16;
